import { render, staticRenderFns } from "./ContractedServicesComponent.vue?vue&type=template&id=bd5766e8"
import script from "./ContractedServicesComponent.vue?vue&type=script&lang=js"
export * from "./ContractedServicesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports